import { getUserLocale } from '../../utils/getUserLocale';
import baseUrl from '../../utils/baseUrl';

export async function requestVerificationCode(email: string, is_promotion_agreed: boolean){

  return fetch(`${baseUrl()}/auth/request_verification_code`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      email: email,
      locale: getUserLocale(),
      is_promotion_agreed: is_promotion_agreed,
      is_terms_agreed: true
    })
  }).then((data) => data.json());
}
